const Loader = () => {
  return (
    <div className='text-center'>
      <span className='spinner-border spinner-border-lg ' role='status' aria-hidden='true'></span>
    </div>
  );
};

export default Loader;
